<template>
  <div class="invoice contentCenter">
    <Modal
        v-model="isShowModal"
        :closable="false"
        footer-hide
        width="40vw"
        class-name="vertical-center-modal invoiceModal"
    >
      <img
          class="closeIcon"
          @click="isShowModal = false"
          src="../../assets/img/close.png"
      />
      <div class="modal" v-if="!isHasInvoice || invoiceCheckFail">
        <Tabs v-model="type" @on-click="handleChangeTab">
          <TabPane label="企业" name="企业">
            <Form
                ref="from"
                :model="company"
                :rules="rules"
                :label-width="110"
            >
              <div class="limitHeight">
                <div class="invoiceTop">
                  <FormItem label="开票类型">
                    <Select
                        v-model="kind"
                        placeholder="开票类型选择"

                    >
                      <Option :value="item.id" v-for="item in invoiceType">{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                  <FormItem label="发票抬头" prop="name">
                    <Input
                        @on-blur="handleLoadBank"
                        v-model="company.name"
                        placeholder="请填写发票抬头"
                    ></Input>
                  </FormItem>
                  <FormItem label="纳税人识别号" prop="registerNo">
                    <Input
                        v-model="company.registerNo"
                        placeholder="请填纳税人识别号"
                    ></Input>
                  </FormItem>
                  <div>
                    <FormItem label="开户行名称" prop="bankName">
                      <Input
                          v-model="company.bankName"
                          placeholder="请填开户行名称"
                      ></Input>
                      <!--                      <Select v-model="company.bankName" placeholder="开银行选择">-->
                      <!--                      <Option-->
                      <!--                        :value="item.bankName"-->
                      <!--                        v-for="(item, index) in bankList"-->
                      <!--                        :key="index"-->
                      <!--                        >{{ item.bankName }}</Option-->
                      <!--                      >-->
                      <!--                    </Select>-->
                    </FormItem>
                    <FormItem label="开户行账户" prop="bankAccount">
                      <Input
                          v-model="company.bankAccount"
                          placeholder="请填开户行账户"
                      ></Input>
                    </FormItem>
                    <FormItem label="公司地址" prop="address">
                      <Input
                          v-model="company.address"
                          placeholder="请填写注册地址"
                      ></Input>
                    </FormItem>
                    <FormItem label="公司电话" prop="tel">
                      <Input
                          v-model="company.tel"
                          placeholder="请填注册电话"
                      ></Input>
                    </FormItem>
                  </div>
                </div>
                <div class="invoiceBottom">
                  <div style="width:390px">
                    <FormItem label="本人手机号" prop="receiveMobile">
                      <Input
                          v-model="company.receiveMobile"
                          placeholder="请填写手机号"
                      ></Input>
                    </FormItem>
                  </div>
                  <FormItem label="收票人邮箱" prop="email">
                    <Input
                        v-model="company.email"
                        placeholder="请填写邮箱"
                    ></Input>
                  </FormItem>
                  <FormItem label="备注" prop="remark">
                    <Input
                        v-model="company.remark"
                        placeholder="请填写备注"
                    ></Input>
                  </FormItem>
                </div>
              </div>
              <div class="footerBtn display-flex">
                <Button
                    type="primary"
                    :loading="btnLoading"
                    class="confirm"
                    @click="handleSubmitModal=true"
                >确认
                </Button
                >
                <Button
                    class="back"
                    @click="isShowModal = false"
                    style="margin-left: 20px;"
                >取消
                </Button
                >
              </div>
            </Form>
            <!--            <Form-->
            <!--                ref="from1"-->
            <!--                v-show="kind == '普通发票'"-->
            <!--                :model="company"-->
            <!--                :rules="rules"-->
            <!--                :label-width="110"-->
            <!--            >-->
            <!--              <div class="limitHeight">-->
            <!--                <div class="invoiceTop">-->
            <!--                  <FormItem label="开票类型">-->
            <!--                    <Select-->
            <!--                        v-model="kind"-->
            <!--                        placeholder="开票类型选择"-->
            <!--                      <Option :value="item.id"    v-for="item in invoiceType">{{item.name}}</Option>-->
            <!--                    </Select>-->
            <!--                  </FormItem>-->
            <!--                  <FormItem label="单位名称" prop="name">-->
            <!--                    <Input-->
            <!--                        @on-blur="handleLoadBank"-->
            <!--                        v-model="company.name"-->
            <!--                        placeholder="请填写单位名称"-->
            <!--                    ></Input>-->
            <!--                  </FormItem>-->
            <!--                  <FormItem label="纳税人识别号" prop="registerNo">-->
            <!--                    <Input-->
            <!--                        v-model="company.registerNo"-->
            <!--                        placeholder="请填纳税人识别号"-->
            <!--                    ></Input>-->
            <!--                  </FormItem>-->
            <!--                  <FormItem label="收票人邮箱" prop="email">-->
            <!--                    <Input-->
            <!--                        v-model="company.email"-->
            <!--                        placeholder="请填写邮箱"-->
            <!--                    ></Input>-->
            <!--                  </FormItem>-->
            <!--                </div>-->
            <!--                <div class="invoiceBottom">-->
            <!--                  <div style="width:390px">-->
            <!--                    <FormItem label="收票人手机号" prop="receiveMobile">-->
            <!--                      <Input-->
            <!--                          v-model="company.receiveMobile"-->
            <!--                          placeholder="请填写手机号"-->
            <!--                      ></Input>-->
            <!--                    </FormItem>-->
            <!--                  </div>-->
            <!--                  <div class="city display-flex">-->
            <!--                    <FormItem label="选择企业所在区域" prop="receiveProvince">-->
            <!--                      <div class="item">-->
            <!--                        <Select-->
            <!--                            v-model="company.receiveProvince"-->
            <!--                            @on-change="handleChangePro"-->
            <!--                            placeholder="省份"-->
            <!--                        >-->
            <!--                          <Option-->
            <!--                              :value="item.id"-->
            <!--                              v-for="item in province"-->
            <!--                              :key="item.id"-->
            <!--                          >{{ item.name }}-->
            <!--                          </Option-->
            <!--                          >-->
            <!--                        </Select>-->
            <!--                      </div>-->
            <!--                    </FormItem>-->
            <!--                    <FormItem label prop="receiveCity">-->
            <!--                      <div class="item">-->
            <!--                        <Select-->
            <!--                            v-model="company.receiveCity"-->
            <!--                            @on-change="handleChangeCity"-->
            <!--                            placeholder="市"-->
            <!--                        >-->
            <!--                          <Option-->
            <!--                              :value="item.id"-->
            <!--                              v-for="item in city"-->
            <!--                              :key="item.id"-->
            <!--                          >{{ item.name }}-->
            <!--                          </Option-->
            <!--                          >-->
            <!--                        </Select>-->
            <!--                      </div>-->
            <!--                    </FormItem>-->
            <!--                    <FormItem label prop="receiveArea" v-if="county.length > 0">-->
            <!--                      <div class="item">-->
            <!--                        <Select-->
            <!--                            v-model="company.receiveArea"-->
            <!--                            placeholder="区/县"-->
            <!--                        >-->
            <!--                          <Option-->
            <!--                              :value="item.id"-->
            <!--                              v-for="item in county"-->
            <!--                              :key="item.id"-->
            <!--                          >{{ item.name }}-->
            <!--                          </Option-->
            <!--                          >-->
            <!--                        </Select>-->
            <!--                      </div>-->
            <!--                    </FormItem>-->
            <!--                    <FormItem label v-show="county.length <= 0">-->
            <!--                      <div class="item">-->
            <!--                        <Select-->
            <!--                            v-model="company.receiveArea"-->
            <!--                            placeholder="区/县"-->
            <!--                        >-->
            <!--                          <Option-->
            <!--                              :value="item.id"-->
            <!--                              v-for="item in county"-->
            <!--                              :key="item.id"-->
            <!--                          >{{ item.name }}-->
            <!--                          </Option-->
            <!--                          >-->
            <!--                        </Select>-->
            <!--                      </div>-->
            <!--                    </FormItem>-->
            <!--                  </div>-->

            <!--                  <FormItem label="企业详细地址" prop="receiveAddress">-->
            <!--                    <Input-->
            <!--                        v-model="company.receiveAddress"-->
            <!--                        type="textarea"-->
            <!--                        :autosize="{ minRows: 2, maxRows: 5 }"-->
            <!--                        placeholder="详细到街道"-->
            <!--                    ></Input>-->
            <!--                  </FormItem>-->
            <!--                  <FormItem label="备注" prop="remark">-->
            <!--                    <Input-->
            <!--                        v-model="company.remark"-->
            <!--                        placeholder="请填写备注"-->
            <!--                    ></Input>-->
            <!--                  </FormItem>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--              <div class="footerBtn display-flex">-->
            <!--                <Button-->
            <!--                    type="primary"-->
            <!--                    :loading="btnLoading"-->
            <!--                    class="confirm"-->
            <!--                    @click="handleSubmit('from1')"-->
            <!--                >确认-->
            <!--                </Button-->
            <!--                >-->
            <!--                <Button-->
            <!--                    class="back"-->
            <!--                    @click="isShowModal = false"-->
            <!--                    style="margin-left: 20px;"-->
            <!--                >取消-->
            <!--                </Button-->
            <!--                >-->
            <!--              </div>-->
            <!--            </Form>-->
          </TabPane>
          <TabPane label="个人" name="个人">
            <Form
                ref="from"
                :model="company"
                :rules="rules"
                :label-width="110"
            >
              <div class="limitHeight">
                <div class="invoiceTop">
                  <FormItem label="开票类型">
                    <Select
                        v-model="kind"
                        placeholder="开票类型选择"

                    >
                      <Option :value="item.id" v-for="item in invoiceType">{{ item.name }}</Option>
                    </Select>
                  </FormItem>
                  <FormItem label="发票抬头" prop="name">
                    <Input
                        @on-blur="handleLoadBank"
                        v-model="company.name"
                        placeholder="请填写发票抬头"
                    ></Input>
                  </FormItem>
                  <FormItem label="纳税人识别号" prop="registerNo">
                    <Input
                        v-model="company.registerNo"
                        placeholder="请填纳税人识别号"
                    ></Input>
                  </FormItem>
                  <div>
<!--                    <FormItem label="开户行名称" prop="bankName">-->
<!--                      <Input-->
<!--                          v-model="company.bankName"-->
<!--                          placeholder="请填开户行名称"-->
<!--                      ></Input>-->
<!--                      &lt;!&ndash;                      <Select v-model="company.bankName" placeholder="开银行选择">&ndash;&gt;-->
<!--                      &lt;!&ndash;                      <Option&ndash;&gt;-->
<!--                      &lt;!&ndash;                        :value="item.bankName"&ndash;&gt;-->
<!--                      &lt;!&ndash;                        v-for="(item, index) in bankList"&ndash;&gt;-->
<!--                      &lt;!&ndash;                        :key="index"&ndash;&gt;-->
<!--                      &lt;!&ndash;                        >{{ item.bankName }}</Option&ndash;&gt;-->
<!--                      &lt;!&ndash;                      >&ndash;&gt;-->
<!--                      &lt;!&ndash;                    </Select>&ndash;&gt;-->
<!--                    </FormItem>-->
<!--                    <FormItem label="开户行账户" prop="bankAccount">-->
<!--                      <Input-->
<!--                          v-model="company.bankAccount"-->
<!--                          placeholder="请填开户行账户"-->
<!--                      ></Input>-->
<!--                    </FormItem>-->
<!--                    <FormItem label="公司地址" prop="address">-->
<!--                      <Input-->
<!--                          v-model="company.address"-->
<!--                          placeholder="请填写注册地址"-->
<!--                      ></Input>-->
<!--                    </FormItem>-->
<!--                    <FormItem label="公司电话" prop="tel">-->
<!--                      <Input-->
<!--                          v-model="company.tel"-->
<!--                          placeholder="请填注册电话"-->
<!--                      ></Input>-->
<!--                    </FormItem>-->
                  </div>
                </div>
                <div class="invoiceBottom">
                  <div style="width:390px">
                    <FormItem label="本人手机号" prop="receiveMobile">
                      <Input
                          v-model="company.receiveMobile"
                          placeholder="请填写手机号"
                      ></Input>
                    </FormItem>
                  </div>
                  <FormItem label="收票人邮箱" prop="email">
                    <Input
                        v-model="company.email"
                        placeholder="请填写邮箱"
                    ></Input>
                  </FormItem>
                  <FormItem label="备注" prop="remark">
                    <Input
                        v-model="company.remark"
                        placeholder="请填写备注"
                    ></Input>
                  </FormItem>
                </div>
              </div>
              <div class="footerBtn display-flex">
                <Button
                    type="primary"
                    :loading="btnLoading"
                    class="confirm"
                    @click="handleSubmitModal=true"
                >确认
                </Button
                >
                <Button
                    class="back"
                    @click="isShowModal = false"
                    style="margin-left: 20px;"
                >取消
                </Button
                >
              </div>
            </Form>
          </TabPane>
        </Tabs>
      </div>

      <Modal
          v-model="handleSubmitModal"
          title="发票提交确认"
          @on-ok="ok"
          @on-cancel="handleSubmitModal = false">
       <div v-if="type == '企业'">
         <p>主体类型:企业</p>
         <p>发票类型:{{ kindName }}</p>
         <p>发票抬头:{{ company.name }}</p>
         <p>纳税人识别号:{{ company.registerNo }}</p>
         <p>开户行名称:{{ company.bankName }}</p>
         <p>开户行账户:{{ company.bankAccount }}</p>
         <p>公司地址:{{ company.address }}</p>
         <p>公司电话:{{ company.tel }}</p>
         <p>备注:{{ company.remark }}</p>


       </div>
       <div v-else>
         <p>主体类型:个人</p>
         <p>发票类型:{{kindName }}</p>
         <p>发票抬头:{{ company.name }}</p>
         <p>纳税人识别号:{{ company.registerNo }}</p>
         <p>手机号:{{ company.receiveMobile }}</p>
         <p>邮箱:{{ company.email }}</p>
         <p>备注:{{ company.remark }}</p>
       </div>
      </Modal>

      <div v-if="isHasInvoice && !invoiceCheckFail" class="invoiceResult">
        <h4 slot="header">电子发票</h4>
        <div class="middle" v-if="invoiceStatus === 2">
          <img src="../../assets/img/invoiceAudit.png" alt/>
          <p class="state">审核中</p>
        </div>
        <div class="middle" v-if="invoiceStatus === -1">
          <img src="../../assets/img/invoiceFail.png" alt/>
          <p class="state">审核失败</p>
          <span v-if="invoiceFailReason">原因:{{ invoiceFailReason }}</span>
        </div>
        <div class="middle" v-if="invoiceStatus === 3">
          <img src="../../assets/img/invoiceSuc.png" alt/>
          <p class="state">开票中</p>
        </div>
        <div class="middle" v-if="invoiceStatus === 1">
          <img src="../../assets/img/invoiceSuc.png" alt/>
          <p class="state">已开票!</p>
        </div>
        <div class="footerBtn display-flex" style="padding-bottom:15px">
          <Button type="primary" class="confirm" @click="handleConfirm">
            {{ invoiceStatus === -1 ? "重新开票" : "确认" }}
          </Button>
          <Button v-if="invoiceStatus === 2" class="back" style="margin-left: 20px;background-color: red;" @click="del">
            撤销申请
          </Button>
          <Button
              class="back"
              @click="isShowModal = false"
              style="margin-left: 20px;"
          >取消
          </Button
          >
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {postData, showLoading, EventBus, postDataNew} from "../../assets/api/api.js";

export default {
  name: "invoice",
  components: {},
  data() {
    const registerNoReg = (rule, value, callback) => {
      /**
       * javascript验证纳税人识别号格式
       */
      let reg = /^([A-Z0-9]{15}|[A-Z0-9]{18}|[A-Z0-9]{20})$/;
      if (reg.test(value)) {
        callback()
        console.log('正确')
      } else {
        //纳税人识别号格式错误
        console.log('错误')
        callback(new Error('纳税人识别号格式错误'));
      }
    }
    return {
      ischange: false,//是否为编辑
      orderId: "",
      comboid: '',
      invoiceStatus: null,
      invoiceFailReason: null,
      province: [],
      city: [],
      county: [],
      isShowModal: false,
      btnLoading: false,
      invoiceCheckFail: false,
      kind: 0,
      type: "企业",
      handleSubmitModal:false,
      bankList: [],
      kindName:'',
      company: {
        name: '',
        receiveMobile: "",
        receiveProvince: "530000",
        receiveCity: "",
        receiveArea: "",
        receiveAddress: "",
        registerNo: "",
        email: '',
        remark: '',
        bankName: "",
        bankAccount: "",
        address: "",
        tel: "",
      },
      invoiceType: [
        {
          id: "0",
          name: "电子普通发票",
        }
      ],
      rules: {
        name: [
          {required: true, message: "发票抬头不能为空", trigger: "blur"},
        ],
        receiveMobile: [
          {required: true, message: "收票人手机号不能为空", trigger: "blur"},
          {
            pattern: /^((\+86)|(86))?1[34578][0-9]\d{8}$/,
            message: "手机号码格式不对",
          },
        ],
        receiveProvince: [
          {required: true, message: "省份不能为空", trigger: "change"},
        ],
        receiveCity: [
          {required: true, message: "城市不能为空", trigger: "change"},
        ],
        receiveArea: [
          {required: true, message: "县/区不能为空", trigger: "change"},
        ],
        receiveAddress: [
          {required: true, message: "详细地址不能为空", trigger: "blur"},
        ],
        registerNo: [
          {required: true, message: "识别号不能为空", trigger: "blur"},
          {validator: registerNoReg, trigger: "blur"},
        ],
        email: [
          {required: true, message: "邮箱不能为空", trigger: "blur"},
          {type: 'email', message: '邮箱格式不正确', trigger: 'blur'}
        ],
        // bankName: [
        //   {required: true, message: "开户行不能为空", trigger: "blur"},
        // ],
        // bankAccount: [
        //   {required: true, message: "账号不能为空", trigger: "blur"},
        // ],
        // address: [
        //   {required: true, message: "注册地址不能为空", trigger: "blur"},
        // ],
        // tel: [{required: true, message: "注册电话不能为空", trigger: "blur"}],
      },
    };
  },
  created() {
    this.loadProvince();
    console.log(this.type)
    this.getInvoiceType();
  },
  mounted() {
  },

  watch:{
    kind(){
      for (let i=0; i<= this.invoiceType.length;i++){
        if (this.invoiceType[i].id==this.kind){
          this.kindName =  this.invoiceType[i].name
          console.log(this.kindName)
          break;
        }
      }
    }
  },
  computed: {
    //没开发票没这个字段或是值为null   0 待审核  1审核通过  -1 审核不通过
    isHasInvoice() {
      return (
          this.invoiceStatus === 3 ||
          this.invoiceStatus === 2 ||
          this.invoiceStatus === -1 ||
          this.invoiceStatus === 1
      );
    },

  },
  methods: {
    // getTypeName(){
    //   let name = "";
    //   // //循环res.data
    //   for (let i=0; i<= this.invoiceType.length;i++){
    //     if (this.invoiceType[i].id==this.kind){
    //       name =  this.invoiceType[i].name
    //       break;
    //     }
    //   }
    //   return name;
    // },
    handleConfirm() {
      if (this.invoiceStatus === -1) {
        this.invoiceCheckFail = true;
      } else {
        this.isShowModal = false;
      }
    },
    //删除发票申请
    del() {
      console.log(this.comboid)
      postData('invoice/delete', {id: this.comboid}).then(res => {
        console.log(res)
        if (res.message == '操作成功') {
          this.$Message.success("撤销成功");
          this.isShowModal = false;
        }
      })
    },
    ok(){
      this.handleSubmit('from');
    },

    handleLoadBank() {
      this.bankList = [];
      if (this.kind == "增值税专用发票" || this.kind == "普通发票") {
        postData("invoice/queryCredit", {keyword: this.company.name}).then(
            (res) => {
              if (res.data) {
                this.bankList.push(res.data);
                this.company.registerNo = res.data.registerNo || "";
                this.company.bankName = res.data.bankName || "";
                this.company.address = res.data.address || "";
                this.company.email = res.data.email || "";
                this.company.remark = res.data.remark || "";
                this.company.tel = res.data.tel || "";
                this.company.receiveMobile =
                    this.$store.state.master.user.phone || "";
              } else {
                this.bankList = [];
              }
            }
        );
      }
    },
    loadProvince() {
      postData("area/list", {}).then((res) => {
        this.province = res.data.map((i) => {
          i.id = i.id.toString();
          return i;
        });
        if (this.ischange) {
          let that = this;
          this.company.receiveProvince = this.province.find(
              (i) => i.name == that.company.receiveProvince
          ).id;
        }
        this.getCity(this.company.receiveProvince);
      });
    },
    getCity(val) {
      postData("area/list", {id: val}).then((res) => {
        this.city = res.data.map((i) => {
          i.id = i.id.toString();
          return i;
        });
        if (this.ischange) {
          let that = this;
          this.company.receiveCity = this.city.find(
              (i) => i.name == that.company.receiveCity
          ).id;
          that.handleChangeCity(this.company.receiveCity)
        }
        this.county = [];
      });
    },

    //获取发票类型
    getInvoiceType() {
      postDataNew("/jxjyapi/tenpoint/getInvoiceType").then(res => {
            console.log(res.data)
            if (res.code === true) {
              this.invoiceType = res.data;
              console.log(this.invoiceType)
            }
          }
      )
    },

    handleChangePro(val) {
      if (val) {
        this.getCity(val);
        // postData("area/list", { id: val }).then(res => {
        //   this.city = res.data.map(i => {
        //     i.id = i.id.toString();
        //     return i;
        //   });
        //   this.county = [];
        // });
      }
    },
    handleChangeCity(val) {
      if (val) {
        postData("area/list", {id: val}).then((res) => {
          this.county = res.data.map((i) => {
            i.id = i.id.toString();
            return i;
          });
          if (this.ischange) {
            let that = this;
            this.company.receiveArea = this.county.find(
                (i) => i.name == that.company.receiveArea
            ).id;
          }
        });
      }
    },
    handleChangeTab(name) {
      this.type = name;
      this.company = {
        name: "",
        receiveMobile: "",
        receiveProvince: "530000",
        receiveCity: "",
        receiveArea: "",
        receiveAddress: "",
        registerNo: "",
        email: "",
        remark: "",
        bankName: "",
        bankAccount: "",
        address: "",
        tel: "",
      };
      if (name == '个人') {
        this.company.name = this.$store.state.master.user.name;
      }
    },
    handleChangeType(val) {
      this.kind = val;
      this.company = {
        name: "",
        receiveMobile: "",
        receiveProvince: "530000",
        receiveCity: "",
        receiveArea: "",
        receiveAddress: "",
        registerNo: "",
        email: "",
        remark: "",
        bankName: "",
        bankAccount: "",
        address: "",
        tel: "",
      };
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {

        const {company, orderId, type} = this;

        var params = {
          order_id: orderId, //订单号
          type: type === "企业" ? 1 : 2, //发票类型
          name: company.name, //发票抬头
          uid: this.$store.state.master.user.id, //用户id
          member_phone: company.receiveMobile, //收件人手机号
        };
        params.invoice_type = this.kind;
        params.duty_number = company.registerNo; //识别号
        params.bank_deposit = company.bankName; //银行名称
        params.bank_account = company.bankAccount; //开户行账户
        params.duty_address = company.address; //公司地址
        params.duty_phone = company.tel; //公司手机号
        params.email = company.email; //邮箱
        params.remark = company.remark; //备注
        //
        postDataNew("/jxjyapi/ApplyInvoice/addInvoiceInfo", params).then(res => {
              this.isShowModal = false;
              this.btnLoading = false;
              this.$emit("loadData");
            }
        )


        console.log(params)
        // if (valid) {
        //   const {company, orderId, type} = this;
        //   var receiveProvince = this.province.find(
        //       (i) => i.id == company.receiveProvince
        //   ).name;
        //   var receiveCity = this.city.find((i) => i.id == company.receiveCity)
        //       .name;
        //   var receiveArea;
        //   if (company.receiveArea) {
        //     receiveArea = this.county.find((i) => i.id == company.receiveArea)
        //         .name;
        //   }
        //   var params = {
        //     orderId,
        //     type,
        //     name: company.name,
        //     userId: this.$store.state.master.user.id,
        //     receiveMobile: company.receiveMobile,
        //     receiveProvince,
        //     receiveCity,
        //     receiveArea,
        //     receiveAddress: company.receiveAddress,
        //   };
        //   if (name != "from2") {
        //     params.kind = this.kind;
        //     params.registerNo = company.registerNo;
        //     if (this.kind == "增值税专用发票") {
        //       params.bankName = company.bankName;
        //       params.bankAccount = company.bankAccount;
        //       params.address = company.address;
        //       params.tel = company.tel;
        //     }
        //   }
        //   params.receiveEmail = company.email;
        //   params.remark = company.remark;
        //   this.btnLoading = true;
        //   if (this.ischange) {
        //     params.id = this.comboid;
        //     postData("invoice/editInvoice", params)
        //         .then((res) => {
        //           this.isShowModal = false;
        //           this.ischange = false;
        //           this.btnLoading = false;
        //           this.$emit("loadData");
        //         })
        //         .catch((err) => {
        //           this.btnLoading = false;
        //         });
        //   } else {
        //     postData("invoice/applyInvoice", params)
        //         .then((res) => {
        //           this.isShowModal = false;
        //           this.btnLoading = false;
        //           this.$emit("loadData");
        //         })
        //         .catch((err) => {
        //           this.btnLoading = false;
        //         });
        //   }
        // }
      });
    },
  },
};
</script>
<style lang="scss">
textarea {
  resize: none !important;
  background: #fff !important;
}

.invoiceModal {
  .limitHeight {
    //height: 350px;
    overflow-y: auto;
  }

  .ivu-input-wrapper {
    display: inline-block;
  }

  .ivu-tabs-nav {
    left: 0 !important;
    margin-left: 0;
  }

  .ivu-tabs-nav .ivu-tabs-tab {
    font-size: 16px;
  }

  .ivu-tabs-ink-bar {
    background-color: #222222;
  }

  .ivu-form-item-required .ivu-form-item-label:before {
    content: "*";
  }

  .ivu-form .ivu-form-item-label {
    float: left;
    text-align: right;
    color: #222222;
    font-size: 14px;
  }

  .ivu-tabs-content {
    // padding-right: 100px;
  }

  .ivu-form-item-content {
    margin-left: 110px !important;
  }

  .city .ivu-form-item-content {
    margin-left: 0 !important;
  }

  .city .ivu-form-item:first-child .ivu-form-item-content {
    // display: flex;
    margin-left: 110px !important;
  }

  .ivu-input {
    line-height: 36px;
    height: 36px;
  }

  .ivu-select-selection {
    line-height: 36px;
    height: 36px;
  }
}

// .ivu-tabs-nav {
//   margin-left: 20px;
// }
// .ivu-tabs-nav .ivu-tabs-tab {
//   // margin-right: 37px;
//   font-size: 16px;
//   color: rgba(153, 153, 153, 1);
//   line-height: 20px;
//   padding: 20px 8px;
// }
// .ivu-tabs-nav .ivu-tabs-tab-active {
//   color: #222222 !important;
//   color: rgba(34, 34, 34, 1);
// }
// .ivu-tabs-ink-bar {
//   background: #222222;
//   height: 3px;
// }
</style>
<style lang="scss" scoped>
.invoiceResult {
  text-align: center;

  .middle {
    margin-top: 70px;
    margin-bottom: 130px;

    .state {
      margin-top: 5px;
    }

    span {
      color: #fe0505;
    }

    img {
      border: 1px dashed #aaa;
    }
  }

  h4 {
    text-align: left;
    font-size: 16px;
    color: #222;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f1f4;
  }
}

.closeIcon {
  cursor: pointer;
  position: absolute;
  top: -30px;
  right: -30px;
  height: 30px;
  width: 30px;
}

.invoiceTop {
  padding-right: 172px;
}

.invoiceBottom {
  padding-right: 102px;
  border-top: 1px dashed #dcdcde;
  margin-top: 30px;
  padding-top: 30px;
}

.city .item {
  margin-right: 10px;
  width: 110px;
}

.footerBtn {
  display: flex;
  justify-content: space-around;
  padding-left: 20px;
  text-align: center;
  margin-bottom: 3px;

  button {
    border: none;
    width: 160px;
    height: 40px;
    line-height: 40px;
    border-radius: 3px;
    color: rgba(255, 255, 255, 1);
    background: #999999;
  }

  .confirm {
    background: rgba(55, 188, 95, 1);
  }
}
</style>
